import { PHONE, PHONE_DISPLAY } from '../../utils/schema';
import { trackPhoneClick } from '../../utils/tracking';
import PhoneIcon from '../landing/PhoneIcon';

export default function CallbackCTA({ t, onOpen, variant = 'dark', placement = 'cta' }) {
  const btnClass = variant === 'yellow'
    ? 'bg-dewalt text-black'
    : 'bg-black text-dewalt';
  return (
    <div className="flex flex-col items-center gap-2.5">
      <button
        onClick={onOpen}
        data-testid="callback-open-btn"
        className={`w-full max-w-[280px] ${btnClass} rounded-2xl px-7 py-4 border-none cursor-pointer shadow-lg transition-all duration-150 active:scale-[0.97] hover:shadow-xl flex items-center justify-center gap-3`}
      >
        <PhoneIcon size={20} />
        <span className="text-[16px] font-extrabold tracking-wide">{t('rentPage.callbackBtn')}</span>
      </button>

      <div className="flex items-center gap-2" data-testid="callback-badge">
        <span className="relative flex h-2 w-2 flex-shrink-0">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-green-500" />
        </span>
        <span className="text-[12px] text-gray-500">{t('rentPage.callbackBadge')}</span>
      </div>

      <a
        href={`tel:${PHONE}`}
        onClick={() => trackPhoneClick(placement)}
        className="text-[12px] text-black/40 hover:text-black/60 transition-colors no-underline mt-0.5"
      >
        {t('rentPage.callbackOr')} {PHONE_DISPLAY}
      </a>
    </div>
  );
}
